// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2UPUi","inputWrap":"styles_inputWrap__3O05h","input":"styles_input__3zHMz"};